import { defineStore } from 'pinia';
import { now } from 'common/utils/date.utils';
import { REFERRAL_CODE_PATTERN } from 'common/constants/referral.constants';
import { normalizeReferralCode } from 'common/utils/referral.utils';

export interface IReferralState {
  code: string | null;
  capturedAt: string | null;
}

export const useReferralStore = defineStore('referral', {
  state: (): IReferralState => ({
    code: null,
    capturedAt: null,
  }),

  getters: {
    hasCode: (state) => Boolean(state.code),
  },

  actions: {
    setCode(raw: string): void {
      const code = normalizeReferralCode(raw);
      if (!REFERRAL_CODE_PATTERN.test(code)) return;

      const isNew = this.code !== code;
      this.code = code;
      if (isNew) this.capturedAt = now().toISOString();
    },

    clear(): void {
      this.code = null;
      this.capturedAt = null;
    },
  },

  persist: true,
});
